// src/components/RoleBasedRedirect.jsx
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/useAuthStore';

export function RoleBasedRedirect() {
    const user = useAuthStore((state) => state.user);

    // Si on n'a pas les rôles, on sécurise en renvoyant au login
    if (!user || !user.roles) return <Navigate to="/login" replace />;

    if (user.roles.includes('ROLE_AGENT')) {
        return <Navigate to="/agent-dashboard" replace />;
    }
    return <Navigate to="/dashboard" replace />;
}